import React from 'react'
import PropTypes from 'prop-types'
import './TextField.css'
import { compose, pure } from 'recompose'

const TextField = ({ idx, handleChange, limitLength, currentText, placeholder, type, disabled }) => {
  return (
    <div styleName="group">
      {disabled ? (
        <input
          styleName="textField"
          type={type}
          maxLength={limitLength}
          value={currentText}
          placeholder={placeholder}
          onChange={e =>
            handleChange({
              targetTitle: e.target.value,
              targetKey: idx
            })
          }
          disabled
        />
      ) : (
        <input
          styleName="textField"
          type={type}
          maxLength={limitLength}
          value={currentText}
          placeholder={placeholder}
          onChange={e =>
            handleChange({
              targetTitle: e.target.value,
              targetKey: idx
            })
          }
        />
      )}
      <span styleName="highlight" />
      <span styleName="bar" />
    </div>
  )
}

TextField.propTypes = {
  idx: PropTypes.number,
  handleChange: PropTypes.func.isRequired,
  limitLength: PropTypes.number,
  currentText: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string.isRequired,
  disabled: PropTypes.bool
}

TextField.defaultProps = {
  currentText: '',
  placeholder: '',
  type: 'text',
  disabled: false
}

export default compose(pure)(TextField)
